module.exports = __webpack_public_path__ + "img/2.950cf98c.jpg";